import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import SuperMatchWorkplaceDetailsOfficeOnlyInput from './SuperMatchWorkplaceDetailsOfficeOnlyInput';
import SuperMatchWorkplaceDetailsOfficeAndRemoteInput from './SuperMatchWorkplaceDetailsOfficeAndRemoteInput';
import SuperMatchWorkplaceDetailsRemoteOnlyInput from './SuperMatchWorkplaceDetailsRemoteOnlyInput';
import SuperMatchWorkplaceDetailsOpenToAllPreferencesInput from './SuperMatchWorkplaceDetailsOpenToAllPreferencesInput';

const SuperProfileWorkplaceDetailsInput = ({ availableCountries }) => {
  const {
    cldr: { teritoryDisplayName },
  } = useSelector((state) => state.i18n);

  const countryOptions = availableCountries.map((country) => {
    return {
      label: teritoryDisplayName(country),
      value: country,
    };
  });

  const regionOptions = [
    {
      label: 'North',
      value: 'NORTH',
    },
    {
      label: 'South',
      value: 'SOUTH',
    },
    {
      label: 'East',
      value: 'EAST',
    },
    {
      label: 'West',
      value: 'WEST',
    },
    {
      label: 'Central',
      value: 'CENTRAL',
    },
    {
      label: 'Capital',
      value: 'CAPITAL',
    },
    {
      label: 'Online/Remote',
      value: 'ONLINE_REMOTE ',
    },
  ];

  return (
    <div className="p-col-12">
      <div className="margin-bottom-0-5">
        <FormattedMessage
          id="account.super-profiles.new.workplace-details"
          defaultMessage="Workplace details"
        >
          {(text) => (
            <label className="field-label">
              {text}
            </label>
          )}
        </FormattedMessage>
      </div>
      <SuperMatchWorkplaceDetailsOfficeOnlyInput countryOptions={countryOptions} regionOptions={regionOptions} />
      <SuperMatchWorkplaceDetailsOfficeAndRemoteInput countryOptions={countryOptions} regionOptions={regionOptions} />
      <SuperMatchWorkplaceDetailsRemoteOnlyInput countryOptions={countryOptions} />
      <SuperMatchWorkplaceDetailsOpenToAllPreferencesInput />
    </div>
  );
};

export default SuperProfileWorkplaceDetailsInput;
